export default __webpack_public_path__ + "media/images/bordcell2-445d2ad44fd7db6437adc006507385ab.png";